import type { ReactNode } from 'react';

/**
 * Isolates text a user typed — a name, an address, a branch name, a reference — from the direction
 * of the interface around it (DESIGN_SYSTEM §5; RI-06).
 *
 * Without it the first strong character of the value decides the order of the whole run: an Arabic
 * name inside the English interface renders as "8 شركة النيل للتجارةa7a", and a Latin name inside
 * the Arabic one drags the neighbouring digits and punctuation with it. `bdi` is direction-isolated
 * by definition, keeps its box in the layout, and adds nothing for a screen reader.
 *
 * Use it for values that come from the user or from the organization's own record — never for our
 * own copy, and never for Latin identifiers (those are isolated as left-to-right, not by direction).
 */
export function UserText({ children, className }: { children: ReactNode; className?: string }) {
  return <bdi className={className}>{children}</bdi>;
}
